// extracted by mini-css-extract-plugin
export default {"header":"styles_header__KQtqi","animation":"styles_animation__rMUat","animationImg":"styles_animationImg__0QQ-2","fade":"styles_fade__aCCfJ","iLogo":"styles_iLogo__DRhiG"};